//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export interface Address {
  line1: string;
  line2: string | null;
  line3: string | null;
  line4: string | null;
  locality: string | null;
  region: string | null;
  postcode: string;
  country: string | null;
  latitude: string | null;
  longitude: string | null;
  source: string | null;
}

export enum DocumentCategory {
  All = 0,
  Permanent = 1,
  Temporary = 2
}

export enum DocumentState {
  All = 0,
  Pending = 1,
  Available = 2,
  Failed = 4,
  Deleted = 8
}

export enum DocumentSubType {
  CAD = 1,
  Legal = 2,
  TechnicalNotes = 3,
  QuoteShopDrawing = 1000,
  DealerQuotePDF = 1001,
  ClientQuotePDF = 1002,
  ClientQuoteAPDF = 1003,
  ClientQuoteBNoItemPricePDF = 1004,
  ClientQuoteCNoItemPriceNoDimPDF = 1005,
  DealerQuoteEIternalPDF = 1006,
  ClientQuoteGNoPricePDF = 1007,
  DealerQuoteHIternalPDF = 1008,
  DealerQuoteDataExport = 1009,
  ClientQuoteSummaryPDF = 1010,
  PurchaseOrderPDF = 2000,
  PurchaseOrderDPDF = 2001,
  PurchaseOrderDDPDF = 2002
}

export interface DocumentTracker {
  dateCreated: string;
  id: string;
  recordVersion: string;
  projectId: string;
  resourceId: string;
  resourceType: ResourceType;
  virtualFilePath: string;
  description: string;
  category: DocumentCategory;
  subType: DocumentSubType;
  state: DocumentState;
}

export interface InputCreateProject {
  project: Project;
  projectReferences: ProjectResourceReference[] | null;
  numberSeed: string;
}

export interface InputCreateProjectDocumentLink {
  links: InputDocumentLink[];
}

export interface InputCreateProjectResourceReference {
  projectId: string;
  resourceId: string;
  typeOf: ResourceType;
  parentTypeOf: ResourceType;
  parentResourceId: string;
}

export interface InputDeleteProject {
  projectId: string;
  recordVersion: string;
}

export interface InputDeleteProjectDocument {
  id: string;
}

export interface InputDeleteProjectResourceReference {
  projectId: string;
  resourceId: string;
}

export interface InputDocumentLink {
  id: string | null;
  projectId: string;
  resourceId: string;
  resourceType: ResourceType;
  virtualFilePath: string;
  description: string;
  category: DocumentCategory;
  state: DocumentState;
  subType: DocumentSubType;
}

export interface InputUpdateProject {
  project: Project;
  stateChangeReason: InputUpdateProjectStateChangeReason | null;
}

export interface InputUpdateProjectDocumentLink {
  links: DocumentTracker[];
}

export interface InputUpdateProjectStateChangeReason {
  stateChangeReason: ProjectStateChangeReason;
  comment: string;
}

export interface Project {
  dateCreated: string;
  id: string;
  recordVersion: string;
  title: string;
  number: number;
  clientId: string;
  contactId: string;
  clientTypeId: string;
  state: ProjectState;
  budget: number | null;
  description: string | null;
  defaultAddress: Address;
  shipToDefaultAddress: boolean;
  shippingNotes: string | null;
  creationUserId: string;
  lastModifiedUserId: string;
  lastModifiedDate: string;
  projectOwnerId: string;
  assignedToUserId: string;
}

export interface ProjectResourceReference {
  resourceId: string;
  typeOf: ResourceType;
  parentTypeOf: ResourceType;
  parentResourceId: string;
}

export enum ProjectState {
  None = 0,
  Active = 1,
  Cancelled = 2,
  Completed = 4
}

export interface ProjectStateChangeReason {
  dateCreated: string;
  id: string;
  recordVersion: string;
  projectStateReasonOwnerId: string;
  category: ProjectState;
  reason: string;
}

export interface ProjectStateChangeReasonPresentation {
  dateCreated: string;
  id: string;
  recordVersion: string;
  projectStateReasonOwnerId: string;
  category: ProjectState;
  itemDisplayOrder: string[];
}

export interface RequestBrowseProjectSummary {
  statesToLoad: ProjectState;
  filter: string | null;
  createdById: string | null;
  pageSize: number;
  pageIndex: number;
  sortField: string | null;
  sortAsc: boolean;
  projectOwnerId: string;
  clientId: string | null;
}

export interface RequestGetPermanentProjectDocuments {
  projectIds: string[];
}

export interface RequestGetProject {
  projectId: string;
}

export interface RequestGetProjectDocument {
  id: string;
}

export interface RequestGetProjectDocuments {
  projectId: string;
}

export interface RequestGetProjectResource {
  projectId: string;
  resourceType: ResourceType;
  pageSize: number;
  pageIndex: number;
}

export interface RequestGetProjectStateChangeReasonsByOwnerIds {
  projectStateReasonsOwnerIds: string[];
}

export interface RequestGetProjectSummaryListByIds {
  projectIds: string[];
}

export interface RequestGetResourceLinks {
  resourceIds: string[];
}

export interface RequestGetResourcesListByIds {
  resourceIds: string[];
}

export interface Resource {
  projectId: string;
  parentResourceId: string;
  parentTypeOf: ResourceType;
  resourceId: string;
  dateCreated: string;
  typeOf: ResourceType;
}

export interface ResourceLink {
  resourceId: string;
  resourceType: ResourceType;
}

export enum ResourceType {
  None = 0,
  Quote = 1,
  PurchaseOrder = 2,
  Invoice = 4
}

export interface ResultBrowseProjectSummary {
  projectSummary: ViewProjectSummaryResultPaginated;
}

export interface ResultBrowseProjectSummaryServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultBrowseProjectSummary | null;
}

export interface ResultCreateProject {
  project: Project;
  resources: Resource[];
  documents: ViewProjectDocument[];
}

export interface ResultCreateProjectDocumentLink {
  projectDocuments: ViewProjectDocument[];
}

export interface ResultCreateProjectDocumentLinkServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultCreateProjectDocumentLink | null;
}

export interface ResultCreateProjectResourceReference {
  projectResourceReference: Resource;
}

export interface ResultCreateProjectResourceReferenceServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultCreateProjectResourceReference | null;
}

export interface ResultCreateProjectServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultCreateProject | null;
}

export interface ResultDeleteProject {}

export interface ResultDeleteProjectDocument {
  successful: boolean;
}

export interface ResultDeleteProjectDocumentServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultDeleteProjectDocument | null;
}

export interface ResultDeleteProjectResourceReference {}

export interface ResultDeleteProjectResourceReferenceServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultDeleteProjectResourceReference | null;
}

export interface ResultDeleteProjectServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultDeleteProject | null;
}

export interface ResultGetPermanentProjectDocuments {
  documents: ViewProjectPermanentDocuments[];
}

export interface ResultGetPermanentProjectDocumentsServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultGetPermanentProjectDocuments | null;
}

export interface ResultGetProject {
  project: Project;
  resources: Resource[];
  documents: ViewProjectDocument[];
}

export interface ResultGetProjectDocument {
  document: ViewProjectDocument;
}

export interface ResultGetProjectDocumentServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultGetProjectDocument | null;
}

export interface ResultGetProjectDocuments {
  projectDocuments: ViewProjectDocument[];
}

export interface ResultGetProjectDocumentsServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultGetProjectDocuments | null;
}

export interface ResultGetProjectResource {
  projectResourceReference: ViewProjectResourceReferenceResultPaginated;
}

export interface ResultGetProjectResourceServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultGetProjectResource | null;
}

export interface ResultGetProjectServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultGetProject | null;
}

export interface ResultGetProjectStateChangeReasonsByOwnerIds {
  projectReasons: ResultProjectStateChangeReasonsForOwnerId[];
}

export interface ResultGetProjectStateChangeReasonsByOwnerIdsServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultGetProjectStateChangeReasonsByOwnerIds | null;
}

export interface ResultGetProjectSummaryListByIds {
  projectSummaries: ViewProjectSummary[];
}

export interface ResultGetProjectSummaryListByIdsServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultGetProjectSummaryListByIds | null;
}

export interface ResultGetResourceLinks {
  resourceLinks: ViewResourceLink[];
}

export interface ResultGetResourceLinksServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultGetResourceLinks | null;
}

export interface ResultGetResourcesListByIds {
  resources: Resource[];
}

export interface ResultGetResourcesListByIdsServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultGetResourcesListByIds | null;
}

export interface ResultProjectStateChangeReasonsForOwnerId {
  projectStateReasonOwnerId: string;
  projectReasons: ResultProjectStateChangeReasonsForState[];
}

export interface ResultProjectStateChangeReasonsForState {
  category: ProjectState;
  presentation: ProjectStateChangeReasonPresentation;
  stateChangeReasons: ProjectStateChangeReason[];
}

export interface ResultUpdateProject {
  project: Project;
  resources: Resource[];
  documents: ViewProjectDocument[];
}

export interface ResultUpdateProjectDocumentLink {
  projectDocuments: ViewProjectDocument[];
}

export interface ResultUpdateProjectDocumentLinkServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultUpdateProjectDocumentLink | null;
}

export interface ResultUpdateProjectServiceResponse {
  responseType: ServiceResponseType;
  readonly responseTypeCaption: string;
  responseError: ServiceResponseError | null;
  result: ResultUpdateProject | null;
}

export interface ServiceResponseError {
  message: string;
  stackTrace: string | null;
}

export enum ServiceResponseType {
  None = 0,
  Ok = 1,
  NotFound = 2,
  UnAuthenticated = 4,
  UnAuthorized = 8,
  Error = 16,
  TransientDbError = 32,
  ValidationFailure = 64,
  ModifyNotFound = 128
}

export interface ViewProjectDocument {
  documentTracker: DocumentTracker;
  publicFileURL: string;
}

export interface ViewProjectPermanentDocuments {
  projectId: string;
  projectDocuments: ViewProjectDocument[];
}

export interface ViewProjectResourceReference {
  projectId: string;
  resourceId: string;
  typeOf: ResourceType;
  parentResourceId: string;
  parentTypeOf: ResourceType;
}

export interface ViewProjectResourceReferenceResultPaginated {
  count: number;
  pageCount: number;
  pageSize: number;
  pageIndex: number;
  results: ViewProjectResourceReference[];
}

export interface ViewProjectSummary {
  id: string;
  title: string;
  number: number;
  clientId: string;
  state: ProjectState;
  dateCreated: string;
  creationUserId: string;
  lastModifiedDate: string;
  assignedToUserId: string;
  installationAddress: Address | null;
}

export interface ViewProjectSummaryResultPaginated {
  count: number;
  pageCount: number;
  pageSize: number;
  pageIndex: number;
  results: ViewProjectSummary[];
}

export interface ViewResourceLink {
  projectId: string;
  resourceType: ResourceType;
  resourceId: string;
  parent: ResourceLink | null;
  childResources: ResourceLink[];
}
